import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from "../stores/auth";
import { showToast, showFailToast } from "vant";

const views = import.meta.glob('../views/**/*.vue');

const routes = [

  // Driver routes
  { path: '/driver/login', component: views['../views/Driver/Login.vue'], meta: { requiresAuth: false } },
  { path: '/driver/sms-login', component: views['../views/Driver/SMSLogin.vue'], meta: { requiresAuth: false } },
  { path: '/driver/register', component: views['../views/Driver/Register.vue'], meta: { requiresAuth: false } },
  { path: '/driver/home', component: views['../views/Driver/Home.vue'], meta: { requiresAuth: true } },
  { path: '/driver/delivery-info', component: views['../views/Driver/DeliveryV2.vue'], meta: { requiresAuth: true } },
  { path: '/driver/wallet', component: views['../views/Driver/Wallet.vue'], meta: { requiresAuth: true } },
  { path: '/driver/unlogin-delivery', component: views['../views/Driver/UnloginDeliveryV2.vue'] },

  // Admin routes
  { path: '/admin/delivery-management', component: views['../views/Admin/Control.vue'] },

  { path: '/', component: views['../views/Index.vue'] },
  // { path: '/driver', component: DriverPage },

  // Public routes
  { path: '/:pathMatch(.*)*', component: views['../views/CommonService/404.vue'] },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  // redirect to home page if has login token
  const isAuthPage = to.path === "/driver/login" || to.path === "/driver/sms-login" || to.path === "/driver/register";
  if (isAuthPage && authStore.token) {
    return next("/driver/home");
  }

  if (to.meta.requiresAuth && !authStore.token) {
    showFailToast("请先登录");
    return next("/driver/login");
  } else {
    next();
  }
});

export default router;
